module.exports = __webpack_public_path__ + "img/car-engine.04135c68.png";